export default class Observer {
  private _handlers;
  private _scope;

  constructor() {
    this._handlers = [];
    this._scope = this || window;
  }

  /**
   * Add new handler.
   * @param {function} handler
   */
  add(handler) {
    if (handler) {
      this._handlers.push(handler);
    }
  }

  /**
   * Excecute all suscribed handlers.
   */
  fire(...params) {
    const args = params;
    this._handlers.forEach((handler) => {
      handler.apply(this._scope, args);
    });
  }

  /**
   * Remove handler from handlers.
   * @param {function} handler
   */
  remove(handler) {
    this._handlers = this._handlers.filter((fn) => {
      if (fn != handler) return fn;
    });
  }
}
